import React from 'react';
import { Route, Switch } from 'react-router';

import JobRequests from './JobRequests';
import JobRequest from './JobRequest';
import Jobs from './Jobs';
import Job from './Job';

const JobRoutes = [
  <Route key="job-request" path="/admin/job-request">
    <Switch>
      <Route
        exact
        title="Job Requests"
        path="/admin/job-request"
        component={JobRequests}
      />
      <Route
        exact
        title="Job Request"
        path="/admin/job-request/:nodeId"
        component={JobRequest}
      />
    </Switch>
  </Route>,
  <Route key="job" path="/admin/job">
    <Switch>
      <Route exact title="Job" path="/admin/job" component={Jobs} />
      <Route exact title="Job" path="/admin/job/:nodeId" component={Job} />
    </Switch>
  </Route>,
];

export default JobRoutes;



// WEBPACK FOOTER //
// ./src/modules/job/JobRoutes.js